import React from 'react';

import { DebugContext } from 'App';

export const useGetError = () => {
	const isDebug = React.useContext(DebugContext);

	const getError = (error, customText) => {
		let messageError = error?.message?.toString();
		if (!isDebug) {
			messageError =
				customText || 'Ha ocurrido un error temporal. Recarga la página por favor.';
		} else {
			console.log('❌ ERROR', error);
		}
		console.log('❌ ERROR', messageError);
		return messageError;
	};

	return getError;
};
